import { ReactNode, ButtonHTMLAttributes, forwardRef } from 'react';
import { ArrowBackIcon, ArrowForwardIcon } from '../Icon';
import { IIconButtonProps, StyledIconButton } from './IconButton';
import { ButtonText } from './ButtonText';

export interface IArrowButtonProps
	extends ButtonHTMLAttributes<HTMLButtonElement>,
		Pick<IIconButtonProps, 'iconPosition'> {
	inverted?: boolean;
	secondary?: boolean;
	textButton?: boolean;
	children: ReactNode;
}

export const ArrowButton = forwardRef<HTMLButtonElement, IArrowButtonProps>(
	(
		{
			inverted,
			secondary,
			textButton,
			children,
			iconPosition = 'right',
			...rest
		}: IArrowButtonProps,
		ref,
	) => (
		<StyledIconButton
			inverted={inverted}
			secondary={secondary}
			textButton={textButton}
			iconPosition={iconPosition}
			{...rest}
			ref={ref}
		>
			{iconPosition === 'left' && <ArrowBackIcon aria-hidden="true" />}
			<ButtonText>{children}</ButtonText>
			{iconPosition === 'right' && <ArrowForwardIcon aria-hidden="true" />}
		</StyledIconButton>
	),
);
